/**
 * Parses first and last name from a Stripe AddressElement value. Prefers the
 * explicit firstName/lastName fields (available when display mode is 'split'),
 * falling back to splitting the combined name field.
 */
export function parseStripeAddressName(address: { firstName?: string; lastName?: string; name: string }): {
  firstName: string;
  lastName: string;
} {
  if (address.firstName || address.lastName) {
    return {
      firstName: (address.firstName ?? '').trim(),
      lastName: (address.lastName ?? '').trim(),
    };
  }

  const trimmed = address.name.trim();
  if (!trimmed) {
    return { firstName: '', lastName: '' };
  }

  const parts = trimmed.split(/\s+/);
  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(' '),
  };
}
